import React, { useState } from "react";
import {
  extractAllContent,
  extractDescription,
  extractImage,
  extractTitle,
} from "../shared/utils/ExtractionUtils";
import * as cheerio from "cheerio";

export default function Explorer() {
  const [url, setUrl] = useState("");
  const [content, setContent] = useState<string[] | string>([]);
  const [title, setTitle] = useState<string>("");
  const [links, setLinks] = useState<string[]>([]);
  const [description, setDescription] = useState<string>("");
  const [image, setImage] = useState<string>("");
  const [loadedContent, setLoadedContent] = useState<string>();

  return (
    <div>
      <input
        type="text"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder="Enter URL"
      />
      <button
        onClick={async () => {
          extractAllContent(url).then((content) => {
            console.log(content.length);
            const $ = cheerio.load(content);
            const article = $(`article, *[class*="content"]`);
            console.log("cheerio", article.text());
            setLoadedContent(article.text());
            const title = extractTitle($);
            const image = extractImage($);
            const description = extractDescription($);
            const links = $("a");

            setTitle(title ?? "");
            setDescription(description ?? "");
            setImage(image ?? "");
            setLinks(links.map((i, el) => $(el).attr("href")).get());
          });
        }}
      >
        Import
      </button>
      <div>
        {title && <h1>{title}</h1>}
        {description && <p>{description}</p>}
        {image && (
          <img
            src={image}
            alt="content"
          />
        )}
        {links && (
          <ul>
            {links.map((link, index) => (
              <li key={index}>
                <a href={link}>{link}</a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
